/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Grid, Loader, Container, Header, Icon, Segment } from "semantic-ui-react";
import { size, map } from "lodash";
import { EventCard } from "../EventCard";
import { Event } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./EventGrid.scss";

const eventController = new Event();

export function EventGrid(props) {
  const { 
    type = "upcoming", // upcoming, featured, past, category
    categoryId = null,
    limit = 12,
    showTitle = true,
    title = "Próximos Eventos"
  } = props;
  
  const [events, setEvents] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    loadEvents();
  }, [type, categoryId, limit]);

  const loadEvents = async () => {
    try {
      let response;

      switch (type) {
        case "upcoming":
          response = await eventController.getUpcomingEvents(accessToken, limit);
          setEvents(response.data);
          break;

        case "featured":
          response = await eventController.getFeaturedEvents(accessToken, limit);
          setEvents(response.data);
          break;

        case "past":
          response = await eventController.getPastEvents(accessToken, 1, limit);
          setEvents(response.data);
          break;

        case "category":
          if (categoryId) {
            response = await eventController.getEventsByCategory(accessToken, categoryId, 1, limit);
            setEvents(response.data);
          }
          break;

        default:
          response = await eventController.getUpcomingEvents(accessToken, limit);
          setEvents(response.data);
      }
    } catch (error) {
      console.error("Error loading events:", error);
      setEvents([]);
    }
  };

  if (events === null) return <Loader active inline="centered" size="large" />;

  if (size(events) === 0) {
    return (
      <Segment placeholder className="event-grid__empty">
        <Header icon>
          <Icon name="calendar times outline" />
          No hay eventos disponibles
        </Header>
      </Segment>
    );
  }

  return (
    <div className="event-grid">
      {showTitle && (
        <Container>
          <Header as="h2" className="event-grid__title">
            {title}
          </Header>
        </Container>
      )}

      <Container>
        <Grid stackable>
          <Grid.Row>
            {map(events, (event) => (
              <Grid.Column key={event.id} computer={4} tablet={8} mobile={16}>
                <EventCard event={event} />
              </Grid.Column>
            ))}
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
}
